import Button from "../common/Button";
import BaseModal from "./BaseModal";

export default function OutboundCallModal({
  open,
  form,
  busy,
  aiConfigs = [],
  onChange,
  onSubmit,
  onClose,
}) {
  return (
    <BaseModal
      open={open}
      onClose={busy ? () => {} : onClose}
      title="Outbound Call"
      meta="Start an outbound call from Calling AI to a contact."
      modalId="outboundModal"
    >
      <form className="outbound-form" onSubmit={onSubmit}>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="obPhone">
            Phone Number
          </label>
          <input
            className="outbound-input"
            id="obPhone"
            name="phone"
            type="tel"
            placeholder="+971501234567"
            value={form.phone}
            onChange={(event) => onChange("phone", event.target.value)}
            required
            disabled={busy}
          />
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="obVoiceProvider">
            Voice Provider
          </label>
          <select
            className="outbound-input"
            id="obVoiceProvider"
            name="voice_provider"
            value={form.voice_provider || "openai"}
            onChange={(event) => onChange("voice_provider", event.target.value)}
            disabled={busy}
          >
            <option value="openai">OpenAI Voice (default)</option>
            <option value="elevenlabs">ElevenLabs — Indian English (demo)</option>
          </select>
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="obName">
            Contact Name
          </label>
          <input
            className="outbound-input"
            id="obName"
            name="name"
            type="text"
            placeholder="Contact name"
            value={form.name}
            onChange={(event) => onChange("name", event.target.value)}
            required={(form.voice_provider || "openai") !== "elevenlabs"}
            disabled={busy}
          />
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="obReason">
            Reason
          </label>
          <input
            className="outbound-input"
            id="obReason"
            name="reason"
            type="text"
            placeholder="appointment reminder"
            value={form.reason}
            onChange={(event) => onChange("reason", event.target.value)}
            disabled={busy}
          />
        </div>
        {aiConfigs.length ? (
          <div className="outbound-field">
            <label className="outbound-label" htmlFor="obAiConfig">
              AI Runtime
            </label>
            <select
              className="outbound-input"
              id="obAiConfig"
              name="ai_config_id"
              value={form.ai_config_id || ""}
              onChange={(event) => onChange("ai_config_id", event.target.value)}
              disabled={busy}
            >
              <option value="">Use default runtime</option>
              {aiConfigs.map((config) => (
                <option
                  key={config.ai_config_id || config.config_id || config.id}
                  value={config.ai_config_id || config.config_id || config.id}
                >
                  {config.name || config.label || `Config ${config.ai_config_id || config.id}`}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        {form.summary ? (
          <div className="modal-summary-block">
            <div className="modal-summary-label">Lead Summary</div>
            <div className="modal-summary-text">{form.summary}</div>
          </div>
        ) : null}
        <div className="outbound-help">
          Use full international format (+971501234567) or local format
          (0501234567).
        </div>
        <div className="outbound-actions">
          <Button onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button type="submit" variant="green" disabled={busy}>
            {busy ? "Calling..." : "Start Call"}
          </Button>
        </div>
      </form>
    </BaseModal>
  );
}
